import React, { FC, useCallback, useState } from 'react';
import { Alert, useCognitoUser, useMe } from 'src/common';
import { extractErrorMessage } from 'src/models/company/Security/helpers';
import { SecurityView } from 'src/models/company/Security/types';
import { MfaMode } from 'src/models/users/types';
import MFaDesc from './MFADesc';
import QrCode from './QrCode';
import GreetMfaActivated from './GreetMfaActivated';
import GreetMfaDeactivated from './GreetMfaDeactivated';
import styles from '../index.module.scss';

interface IProps {
  email?: string;
  isAdmin: boolean;
}

export const MFA: FC<IProps> = props => {
  const { email, isAdmin } = props;

  if (!email) {
    throw new Error('Email is not defined');
  }
  const { value: cognitoUser, error: cognitoUserError } = useCognitoUser();

  const { data } = useMe();
  const isMfaActive = data?.mfaMode === MfaMode.TOTP;

  const [code, setCode] = useState('');

  const [view, setView] = useState(SecurityView.mfaDesc);

  const onBackClick = useCallback(() => {
    setView(SecurityView.mfaDesc);
  }, []);

  const onSetCode = useCallback(code => {
    setCode(code);
    setView(SecurityView.qrCode);
  }, []);

  const onMFACodeConfirmed = useCallback(async () => {
    setView(SecurityView.greetMfaActivated);
  }, []);
  return (
    <div className={styles.container}>
      {cognitoUserError && <Alert message={extractErrorMessage(cognitoUserError)} type={'error'} />}
      {view === SecurityView.mfaDesc && (
        <MFaDesc
          isAdmin={isAdmin}
          email={email}
          setView={setView}
          onSetCode={onSetCode}
          cognitoUser={cognitoUser}
          isMfaActive={isMfaActive}
        />
      )}
      {view === SecurityView.qrCode && (
        <QrCode
          code={code}
          onBackClick={onBackClick}
          onFinish={onMFACodeConfirmed}
          email={email}
          cognitoUser={cognitoUser}
        />
      )}
      {view === SecurityView.greetMfaActivated && <GreetMfaActivated onBackClick={onBackClick} />}
      {view === SecurityView.greetMfaDeactivated && <GreetMfaDeactivated onBackClick={onBackClick} />}
    </div>
  );
};

export default MFA;
